@let event = streappEvent();
@if (event) {
<div>
    <h2>{{ "event_steps.step_price.label" | translate }}</h2>
    @if (!authService.isStreapper) {
    <p> {{ "event_steps.step_price.non_reporter_askingprice_text" | translate }} </p>
    }
    @if (!authService.isStreapper) {
    <mat-slide-toggle [checked]="isAskingPriceEnabled()"
        (change)="isAskingPriceEnabled.set($event.checked)"></mat-slide-toggle>
    }
    <ng-template matStepLabel>{{
        "event_steps.step_price.label" | translate
        }}</ng-template>
    <!-- All uploaded files with prices/suggested prices -->
    <h2 class="price-title">
        {{ "event_steps.step_price.streapp_title" | translate }}
    </h2>
    @if (authService.isStreapper || isAskingPriceEnabled()) {
    <div class="price-suggestion-holder">
        @for (item of event.preUploadedMediaItems; track item; let i = $index) {
        <div class="price-suggestion-item" [ngStyle]="{ 'background-image': 'url(' + item.previewFile + ')' }"
            (click)="openPriceSelectionWindow(i, 'none')">
            <button class="price-suggestion-button" type="button" mat-raised-button
                (click)="openPriceSelectionWindow(i, 'none')">
                @if (!item.priceChanged) {
                <span>{{
                    "event_steps.step_price.suggestion_label" | translate
                    }}
                    {{ item.suggestedPrice }} <b>€</b></span>
                }
                @if (item.priceChanged) {
                <span> {{ item.price }} <b>€</b></span>
                }
            </button>
        </div>
        }
        <div class="advice-description">
            {{ "event_steps.step_price.advice_description" | translate }}
        </div>
    </div>
    }
    @if (event.preUploadedShopMediaItems.length > 0) {
    <h2 class="price-title shop-only-content-title">
        {{ "event_steps.step_media_upload.shop_only_title" | translate }}
    </h2>
    <div class="price-suggestion-holder">
        <!-- Shop only items -->
        @for (item of event.preUploadedShopMediaItems; track item; let i = $index) {
        <div class="price-suggestion-item" [ngStyle]="{
                  'background-image': 'url(' + item.previewFile + ')'
                }" (click)="openPriceSelectionWindow(i, 'shop')">
            <button class="price-suggestion-button" type="button" mat-raised-button
                (click)="openPriceSelectionWindow(i, 'shop')">
                @if (!item.priceChanged) {
                <span>{{
                    "event_steps.step_price.suggestion_label" | translate
                    }}
                    {{ item.suggestedPrice }} <b>€</b></span>
                }
                @if (item.priceChanged) {
                <span>
                    {{ item.price }} <b>€</b></span>
                }
            </button>
        </div>
        }
        <div class="advice-description">
            {{ "event_steps.step_price.advice_shop" | translate }}
        </div>
    </div>
    }
</div>
}